var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeScript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "#FF4D4D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 15H61.0938C63.2511 15 65 16.7489 65 18.9062V61.0938C65 63.2511 63.2511 65 61.0938 65H18.9062C16.7489 65 15 63.2511 15 61.0938V18.9062C15 16.7489 16.7489 15 18.9062 15Z",
    fill: "#FF4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7735 37.985H44.2167V42.2048H37.6112V60.9786L37.4361 61.0264C37.1973 61.0901 34.0537 61.0901 33.3772 61.0185L32.836 60.9707V42.2048H26.2305V37.985L28.3236 37.9612C29.4696 37.9452 32.4142 37.9452 34.8655 37.9612C37.3167 37.9771 40.4205 37.985 41.7735 37.985Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6875 56.2502L48.5134 54.0351C49.5205 55.6798 50.8295 56.888 53.1452 56.888C55.0921 56.888 56.3336 55.9146 56.3336 54.572C56.3336 52.961 55.0583 52.3904 52.9102 51.4509L51.7358 50.9471C48.3458 49.5042 46.0969 47.6918 46.0969 43.8655C46.0969 40.3414 48.7819 37.6562 52.9775 37.6562C55.9646 37.6562 58.1127 38.6968 59.6564 41.4155L55.998 43.7647C55.1924 42.3216 54.32 41.7512 52.9776 41.7512C51.6015 41.7512 50.7288 42.6238 50.7288 43.7647C50.7288 45.1744 51.6015 45.7451 53.615 46.6178L54.7896 47.1213C58.7837 48.8331 61.0325 50.5782 61.0325 54.5049C61.0325 58.7341 57.7098 61.0497 53.246 61.0497C48.8828 61.0497 46.0635 58.9689 44.6876 56.2502",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeScript);
export default __webpack_public_path__ + "static/media/TypeScript.67af90b6b2648787d89bbd6b3d0da493.svg";
export { ForwardRef as ReactComponent };